const doc = [({"en":({"js":({"users":({"consent":({"index":({"i_consent_to_the_terms":"I consent to the terms", "the_settings_were_saved":"The settings were saved"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;